import { Flex, Icon } from "../ui/provider";

interface NavbarMobileButtonProps {
  label: string;
  icon: React.ElementType;
  isActive: boolean;
  onClick: () => void;
}

const NavbarMobileButton = ({
  label,
  icon: IconComponent,
  isActive,
  onClick
}: NavbarMobileButtonProps) => (
  <Flex
    flex={1}
    flexFlow='column'
    alignItems='center'
    color={isActive ? 'navigationBar.active' : 'navigationBar.inative'}
    transition="color 0.3s ease-in"
  >
    <Flex
      as="button"
      flexFlow='column'
      alignItems='center'
      gap={1}
      onClick={onClick}
      cursor="pointer"
      aria-pressed={isActive}
      data-testid={`mobile-button-${label}`}
    >
      <Icon boxSize={5}>
        <IconComponent weight={isActive ? 'fill' : 'regular'} />
      </Icon>
      {label}
    </Flex>
  </Flex >
);

export default NavbarMobileButton;
